import { useState } from 'react';
import { DeleteButton, EditButton, TableData, TableRow } from '@frontend/components/elements/common';
import { DisplayFullName } from '@frontend/components/elements/DisplayFullName';
import { EditMaxGradingsModal } from '@frontend/components/elements/modals/EditMaxGradingsModal';
import type { IPractitionerNameProperties } from '../../interfaces/serviceGraderPoolInterfaces';

export function ServiceGraderPoolProviderRow(props: IPoolProviderRowProps) {
    const [showModal, setShowModal] = useState(false);

    return (
        <TableRow>
            <TableData>
                <DisplayFullName {...props.practitioner} />
            </TableData>
            <TableData>{props.organization.name}</TableData>
            <TableData>{props.maxGradingsPerMonth ?? ''}</TableData>
            <TableData>{props.maxGradingsPerDay ?? ''}</TableData>
            <TableData align="right">
                <EditButton onClick={() => setShowModal(true)} />
                <DeleteButton
                    onClick={() =>
                        props.deleteServiceGraderPoolProvider(
                            props.serviceGraderPoolProviderId,
                            props.serviceProviderId
                        )
                    }
                />
                <EditMaxGradingsModal
                    isOpen={showModal}
                    maxGradingsPerDay={props.maxGradingsPerDay}
                    maxGradingsPerMonth={props.maxGradingsPerMonth}
                    onCancel={() => setShowModal(false)}
                    onSave={handleSave}
                ></EditMaxGradingsModal>
            </TableData>
        </TableRow>
    );

    function handleSave(updatedMaxGradingsPerDay: number | null, updatedMaxGradingsPerMonth: number | null) {
        setShowModal(false);
        props.editServiceGraderPoolProvider(
            props.serviceProviderId,
            updatedMaxGradingsPerDay,
            updatedMaxGradingsPerMonth
        );
    }
}

interface IPoolProviderRowProps {
    deleteServiceGraderPoolProvider: (serviceGraderPoolProviderId: string, serviceProviderId: string) => Promise<void>;
    editServiceGraderPoolProvider: (
        serviceProviderId: string,
        maxGradingsPerDay: number | null,
        maxGradingsPerMonth: number | null
    ) => Promise<void>;
    maxGradingsPerDay: number | null;
    maxGradingsPerMonth: number | null;
    organization: IOrganization;
    practitioner: IPractitionerNameProperties;
    serviceGraderPoolProviderId: string;
    serviceProviderId: string;
}

interface IOrganization {
    name: string;
}
